<template>
  <div>
    <v-container style="padding: 0;">
      <p class="display-3 font-weight-light text-center pa-4">SHOPPING CART</p>
      <v-row>
        <v-col :cols="12" md="9" sm="12">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">ITEM</th>
                  <th class="text-center">PRICE</th>
                  <th class="text-center">QUANTITY</th>
                  <th class="text-center">TOTAL</th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in cart" :key="item.id">
                  <td class="text-center">
                    <v-list-item key="1">
                      <v-list-item-avatar>
                        <v-img :src="item.productVariant.image.src"></v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.productVariant.title }}
                        </v-list-item-title>
                        <v-list-item-subtitle></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </td>

                  <td class="text-center" cy-data="cy_shop_cart_price">
                    ${{
                      parseFloat(item.productVariant.price.amount).toFixed(2)
                    }}
                  </td>
                  <td class="text-center">
                    <div>
                      <v-text-field
                        style="width: 50%; margin: 0 auto;"
                        v-model="item.quantity"
                        v-on:input="
                          changeItemQuantity(item.variantId, item.quantity)
                        "
                        cy-data="cy_shop_cart_quantity"
                        type="number"
                      ></v-text-field>
                    </div>
                  </td>
                  <td class="text-center">
                    <v-list-item>
                      <v-list-item-title
                        align="center"
                        cy-data="cy_shop_cart_total"
                      >
                        {{ calculateItemTotalPrice(item) }}
                      </v-list-item-title>
                    </v-list-item>
                  </td>
                  <td>
                    <a
                      cy-data="cy_shop_cart_delete"
                      @click="deleteProductFromCart(item.variantId)"
                      >X</a
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <v-col :cols="12" md="3" sm="12" style="background-color: lightgray">
          <p class="headline">Order Summary</p>
          <p class="overline">
            Shipping and additional costs are calculated based on values you
            have entered.
          </p>
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>Order Subtotal</td>
                  <td class="text-right" style="width: 50px;">
                    {{ orderSubTotal ? orderSubTotal.toFixed(2) : "0.00" }}
                  </td>
                </tr>
                <tr>
                  <td>Shipping Charges</td>
                  <td class="text-right" style="width: 50px;">
                    ${{ shippingCharges }}
                  </td>
                </tr>
                <tr>
                  <td>Tax</td>
                  <td class="text-right" style="width: 50px;">${{ tax }}</td>
                </tr>
                <tr>
                  <td>Total</td>
                  <td class="text-right" style="width: 50px;">
                    <b>${{ getCartTotalPrice.toFixed(2) }}</b>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div cy-data="cy_shop_cart_Pay" class="text-center">
            <v-btn class="primary white--text mt-5" outlined @click="CHECKOUT">
              PROCEED TO PAY
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="secondary">
      <v-container>
        <v-row no-gutters>
          <v-col class="col-12 col-md-4 col-sm-12">
            <v-row>
              <v-col class="col-12 col-sm-3 pr-4 hidden-sm-only" align="right">
                <v-icon class="display-2">mdi-truck</v-icon>
              </v-col>
              <!-- <v-col class="col-12 col-sm-9 pr-4">
                <h3 class="font-weight-light">FREE SHIPPING</h3>
                <p class="font-weight-thin">Free Shipping over $300</p>
              </v-col>-->
            </v-row>
          </v-col>
          <v-col class="col-md4 offset-md-6">
            <h2 class="close" @click="$emit('closeCart')">close</h2>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<style scoped lang="scss">
.cart {
  background: white;
}
.close {
  cursor: pointer;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    rating: 4.5,
    breadcrums: [
      {
        text: "Home",
        disabled: false,
        href: "breadcrumbs_home"
      },
      {
        text: "Clothing",
        disabled: false,
        href: "breadcrumbs_clothing"
      },
      {
        text: "T-Shirts",
        disabled: true,
        href: "breadcrumbs_shirts"
      }
    ]
  }),
  methods: {
    deleteProductFromCart(id) {
      //reach out of Vuex store, fire action that gets Drill
      this.$store.dispatch("deleteProductFromCart", { id });
    },
    calculateItemTotalPrice(item) {
      return (
        parseFloat(item.productVariant.price.amount) * item.quantity
      ).toFixed(2);
    },
    showInfo() {
      console.log("HAHA");
    },
    changeItemQuantity(id, quantity) {
      this.$store.commit("incrementItemQuantityCart", {
        variantId: id,
        quantity: quantity
      });
    },
    ...mapActions(["CHECKOUT"])
  },
  computed: {
    ...mapGetters(["loading", "error", "products", "cart", "cartHasProducts"]),
    orderSubTotal() {
      console.log(this.cart); // Check cart contents
      return this.cartHasProducts
        ? this.cart.reduce((reducer, item) => {
            const price = parseFloat(item.productVariant.price.amount) || 0;
            return reducer + price * item.quantity;
          }, 0)
        : 0.0;
    },
    getCartTotalPrice() {
      return this.cartHasProducts === true
        ? this.orderSubTotal + this.shippingCharges + this.tax
        : 0.0;
    },
    tax() {
      return this.cartHasProducts === true ? 5.0 : 0.0;
    },
    shippingCharges() {
      return this.cartHasProducts === true ? 10.0 : 0.0;
    }
  },
  beforeCreate() {
    this.$store.commit("initCart");
  }
};
</script>
